import React, { useRef, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import block from 'bem-cn'

import logo from 'shared/img/logo.webp'

import { useOutsideClick } from 'shared/hooks/useOutsideClick'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'

import { AgentLinkButton } from 'components/AgentLinkButton/AgentLinkButton'
import Search from 'components/Header/Search/Search'
import { PromotionsButton } from 'components/PromotionsButton/PromotionsButton'
import SetLanguage from 'components/SetLanguage/SetLanguage'
import WheelButton from 'components/WheelGame/WheelButton/WheelButton'

import UserBlock from '../UserBlock/UserBlock'

import './TopHeader.scss'

const b = block('top-header')

export const TopHeader = () => {
  const locale = useSelector(selectLocaleDict, shallowEqual).common
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false)
  const searchRef = useRef<HTMLDivElement>(null)

  useOutsideClick(searchRef, () => setIsSearchOpen(false))

  return (
    <div className={b()}>
      <div className={b('left')}>
        <SetLanguage />
        <div className={b('wheel-container')}>
          <WheelButton />
        </div>
      </div>

      <Link to="/" className={b('logo-link')} aria-label={locale.home}>
        <img src={logo} className={b('logo')} alt="logo" />
      </Link>

      <div className={b('right')}>
        {isAuth && <PromotionsButton />}
        <div ref={searchRef} className={b('search-container')}>
          <Search isOpen={isSearchOpen} setIsOpen={setIsSearchOpen} placeholder={locale.search} />
        </div>
        <AgentLinkButton isStatic />
        <UserBlock />
      </div>
    </div>
  )
}
